import { Goto } from "@/shared/navigation/Goto";

/** The id of the Details tab's ingestion panel, which links scroll to. */
export const SESSION_INGESTION_ANCHOR = "session-ingestion";

/** The Details tab, scrolled to its ingestion panel. */
export function sessionIngestionPanelLink(sessionId: string) {
  return {
    // The Sessions feature's `SessionTab.Details`, which shared code can't import.
    pathname: `${Goto.createSessionRoute(encodeURIComponent(sessionId))}/details`,
    hash: SESSION_INGESTION_ANCHOR,
  };
}
